import { defineComponent as _defineComponent } from 'vue';
import ScheduleForm from "@/components/ScheduleForm.vue";
import moment from "moment";
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router/composables";
import { useActions } from "vuex-composition-helpers";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScheduledTasks',
    setup(__props) {
        const schedule = ref({
            times: [
                moment().format('HH:mm')
            ],
            weekdays: [],
            months: [],
            enabledDateRange: [],
        });
        const instance = getCurrentInstance()?.proxy;
        const feedId = useRoute().params.id;
        const scheduleId = ref(null);
        const { create: addSchedule, patch: updateSchedule, find: fetchSchedule } = useActions('schedule', ['create', 'patch', 'find']);
        onMounted(() => {
            fetchSchedule({ query: { feedId } }).then((schedulesResponse) => {
                const fetchedSchedule = schedulesResponse.data[0];
                schedule.value = fetchedSchedule;
                scheduleId.value = fetchedSchedule._id ?? null;
                enabled.value = fetchedSchedule.enabled;
            });
        });
        function save() {
            let promise;
            const scheduleBody = {
                enabled: enabled.value,
                feedId: feedId,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                ...schedule.value
            };
            if (scheduleId.value) {
                promise = updateSchedule([scheduleId.value, scheduleBody, {}]);
            }
            else {
                promise = addSchedule(scheduleBody);
            }
            promise.then((response) => {
                scheduleId.value = response._id ?? null;
                instance?.$toasted.global.success({
                    message: 'Schedule is activated',
                });
            }).catch((error) => instance?.$toasted.global.error(error));
        }
        const enabled = ref(true);
        watch(enabled, (value) => scheduleId.value ? updateSchedule([scheduleId.value, { enabled: value }, {}]).then((response) => {
            scheduleId.value = response._id ?? null;
            instance?.$toasted.global.success({
                message: 'Schedule is updated',
            });
        }).catch((error) => instance?.$toasted.global.error(error)) : null);
        return { __sfc: true, schedule, instance, feedId, scheduleId, addSchedule, updateSchedule, fetchSchedule, save, enabled, ScheduleForm };
    }
});
